import { InventoryLocation } from 'inventory-web'

export default function getSubHeaderText( inventoryLocations: InventoryLocation[], selectedIds: string[], pageTitle: string ): string {
	if ( !inventoryLocations.length ) {
		return ''
	}

	if ( !selectedIds.length ) {
		return 'Showing all stores'
	}

	const firstName = inventoryLocations.find( ( location ) => location.id === selectedIds[ 0 ] )?.name

	return `Displaying ${firstName} ${pageTitle}${selectedIds.length > 1 ? ` and ${selectedIds.length - 1} more` : ''}`
}
